namespace Sapphire {
    export class HideReelsCmd {

        @inject('LayerManager') _layerManager: LayerManager;

        execute(): void {
            this._layerManager.setVisibility('Reels', false);
        }
    }
}